<template>
  <div>
    <Nav isActive="Test"/>    
    <div class="pageWD mT20" >
      <div>  
           
        <el-row :gutter="20">
          <el-col :span="6">         
            <div :class="isScroll?'shadowBox  scrollCsss':'shadowBox '" >
              <div class="mainTop f18 c3">答题卡</div>
                <div class="cardItem">
                  <div class="st flex"><span class="f16 c3 s1">未答</span><span  class="f16 c3 s2">已答</span></div>
                  <div v-if="list_dx.length > 0">   
                    <div class="flex flexitem"  :style="{'height':leftht+'px'}" >                                                    
                      <div class="item" v-for="(item,index) in list_dx" :key="index" :class="[item.answer=='1'?'select':'']" @click="goAnchor('#choose'+item.QT_Index)">{{item.QT_Index}}</div> 
                    </div>                      
                  </div>                  
                </div>
            </div>   
             <div class="minHeight" style="width:285px"></div>       
            </el-col>
            <el-col :span="18">    
              <div class="shadowBox minHeight" v-if="pageData">
                  <div class="mainTop f18 c3">{{pageData.info.exTitle}}</div>
                  <div class="subItems" v-for="(item,index) in questions" :key="index" :id="'choose'+(index+1)">
                      <div class="subl">
                          <div class="title single">
                              <span class="d">{{item.QT_Index}}.</span>
                              <span class="t">单选题</span>
                              <span class="d" v-html="item.QT_Content"></span>
                          
                          </div>
                          <div class="items" >                    
                              <el-radio-group v-model="item.AN_Content" @change="changeType(item.QT_Index,item.AN_Content)" >
                                <div v-for="(_item,index) in item.items" :key="index" > 
                                  <el-radio :label="_item.type">{{_item.siContent}}</el-radio>
                                </div>
                              </el-radio-group>
                          </div>
                                          
                      </div>                    
                </div>             
              </div>         
          </el-col>
        </el-row>    
    </div> 
   </div>
<div style="height:92px"></div>   
   <div class="cardFotter shadowBox" >
       <div class="pageWD" style="text-align:right;padding-top:13px">
         <el-button type="primary"  style="width:83px" @click="subForm">提交</el-button>
       </div>
   </div>
<div style="position:fixed;left:0;top:0;right:0;bottom:0;width:100%;height:100%; opacity: 0.5;
background: #000;overflow:hidden; z-index:4"  v-if="dialogVisible" ></div>
<div class="fixdalert" v-if="dialogVisible">
    <div class="dep" :style="{width:imgWt,height:imgHt}">
      <div class="closex">
        <i class="iconfont icon-a-5_guanbi" @click="tapHide" style="color:#ccc;background:#fff;border-radius:50%;font-size:24px"></i>
      </div>
      <div class="in">
        <img src="../../assets/images/test/zycp_shiwuxing_a.jpg" v-if="type1=='0'" />
        <img src="../../assets/images/test/zycp_guanlixing_a.jpg" v-if="type1=='1'" />
        <img src="../../assets/images/test/zycp_shehuixing_a.jpg" v-if="type1=='2'" />
        <img src="../../assets/images/test/zycp_chuangxin_a.jpg" v-if="type1=='3'" />
        <img src="../../assets/images/test/zycp_yanjiuxing_a.jpg" v-if="type1=='4'" />
        <img src="../../assets/images/test/zycp_jineng_a.jpg" v-if="type1=='5'" />
        <div class="jiedu">
         <div class="l">类型解读</div>
         <div class="d">{{typeArrDetail[type1]}}</div>
        </div>
         <div  class="fbtn">
          <el-button type="primary"  style="width:50%;height:44px; line-height:44px;font-size:20px;margin:0px 10px 0px 0; border:0;color:#4B8BFB;background:#fff" @click="tapRet">重新测评</el-button>
          <el-button type="primary"  style="width:20%;height:44px;line-height:44px;font-size:20px;margin:0px auto" @click="tapClose">关闭</el-button>
         </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
var testData1 = require('@/assets/testdata1.json');
import Cookies from "js-cookie";
import {fieldSave} from '@/api/api'
import Nav from "../../components/Nav.vue";
var typeArrName = ['事务型','管理型','社会型','创新型','研究型','技能型']
  var numArr
      = [0,0,0,0,0,0]
export default {  
  components: { Nav}, 
   data() {
      return {
        radiot:'1',
        typeArrDetail :[
          '事务型的人细致、友善、踏实，有比较强的计划性，经常给自己制定工作和活动计划，并认真严格、有条不紊地执行；做事情注重细节，讲求精确，原则性比较强，喜欢按照规章制度办事，具有比较强的服从性，能够很好地完成分派的任务，生活比较有规律。适合从事的职业岗位有秘书、文员、档案管理员、图书管理员等工作。',
          '管理型的人外向、自省、有说服力、乐观。喜欢有胆略的活动，敢于 冒险。支配欲强，对管理和领导工作感兴趣。通常喜欢追求权力、财富、 地位。善于锌令，总是力求使别人接受自己的观点，具有劝说、调配人的才能。自认为很受他人欢迎，缺乏从事细致工作的耐心。不喜欢那些需要 长期智力活动的工作，管理型的人头脑清楚，思维敏捷.是可靠的生活和 社会的保障。适合从事的职业岗位有企业高管、行政管理。',
          '喜欢与人交流，不断结交新朋友，善于交谈，乐于教导他人。关心社会问题，渴望发挥自己的社会作用。寻求广泛的人际关系，更加注重社会责任和社会公德，喜欢与人共事，能不断结交新朋友，从事提供信息、启迪、帮助、培训、发展或治疗，并具有相应的能力。适合从事的职业岗位有教育工作者（教师、教育行政人员）、社会工作者（顾问、公关人员）。',
          '创新性人格的特点，是以服务社会为己任，敬业爱岗，刻苦钻研，开拓进取，坚韧不拔。面对信息的瞬息万变，竞争的日趋激烈，要形成一时的竞争优势容易，而要形成持续的竞争优势则十分困难。创新人格作为创新个体相对稳定的心理模式，持续表现出创新意愿和创新倾向的习惯性，坚定的自信、坚忍的毅力、开放的思维、自制的意志等都是创新主体进行创新活动的心智要素。适合从事的职业岗位有文学文艺创作、设计类、新媒体工作。',
          '抽象能力强，求知欲强，肯动脑筋，善思考。喜欢独立和富有创造性的工作。喜欢从自然界变化等各种事物中发现奥妙之处，并迫不及待地想要追根究底；他们通常喜欢做统计分析，具备从事调查、观察、评价、推理等方面活动的能力。不善于领导他人。适合从事的职业岗位有科学研究和科学实验工作。',
          '通常具备机械操作能力，适合与机械、工具、动植物等具体事物打交道，他们具有实干家的精神，喜好乐此不疲地对具体事物进行研究。动手能力强，但不善言辞，不善交际。适合从事的职业岗位有各类工程技术工作等,通常需要运用工具或操作机械。'
        ],
        dialogVisible:false,
        pageTestData:null,
        LeaveIndex :true,
        type1:0,
        maxtime:'',
        msg:'',
        Letter:["","A","B","C","D","E","F","G","H","I","J","K","L","M","N"],        
        showtype:false,
        tiId:this.$route.query.taskTI_ID,
        exId:this.$route.query.liId,
        pageData:null,
        percent_:'',
        hg:'',
        zdsc:'',
        list_dx:[],
        list_dd:[],
        list_pd:[],
        list_tk:[],
        list_jd:[],
        questions:[],
        heightNum:null,
        imgHt:null,
        imgWt:null,
        leftht:null,
        isScroll:false
      };
    },
    created() {  
      console.log(testData1.body.result   )
      this.pageData = testData1.body.result    
      this.questions = testData1.body.result.questions
       this.questions.forEach(function(item) { 
                if(item.AN_Content){
                  item.AN_Content = null
                }
       })      
      this.getExamCardFun()
    
      this.heightNum = document.documentElement.clientHeight
      var ht =  document.documentElement.clientHeight - 70//577       
      var b = 842/ht
      this.imgWt = parseInt(711/b)+'px'
      this.imgHt = ht +'px'     
      this.leftht = (parseInt(this.heightNum) -270)
      console.log(this.leftht)
    },
    mounted () {      
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {  
        handleScroll () {
              var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
              console.log(scrollTop)
              if (scrollTop > 200) {
                    this.isScroll = true
                } else {
                    this.isScroll = false
                }
          },
      goAnchor(selector) {
          document.querySelector(selector).scrollIntoView({
              behavior: "smooth"
          });             
      },
      changeType(QT_Index,AN_Content){
          var that = this       
          this.list_dx.forEach(function(item) { 
            if(item.QT_Index == QT_Index){
                item.answer='1';
                item.AN_Content = AN_Content
            }
          })                     
      } , 
      tapHide(){
         this.dialogVisible = false
      },
      tapRet(){
        this.$router.go(0) 
      },
      getMaxIndex(arr) {
        var max = arr[0];       
        var index = 0;
        for (var i = 0; i < arr.length; i++) {
            if (max < arr[i]) {
                max = arr[i];
                index = i;
            }
        }
        return index;
      },
      tapClose(){
       this.$router.push({path:'/test'});
      },
      subForm(){
          var that = this
          var len = 0
          this.list_dx.forEach(function(item) { 
            if(item.answer == '1'){
                len++
            }
          })  
          console.log(len)
          if(len == this.list_dx.length){
                this.list_dx.forEach(function(item) { 
                  if(item.AN_Content=='1'){
                      numArr[0]++
                  }
                   if(item.AN_Content=='2'){
                      numArr[1]++
                  }
                   if(item.AN_Content=='3'){
                      numArr[2]++
                  }
                   if(item.AN_Content=='4'){
                      numArr[3]++
                  }
                  if(item.AN_Content=='5'){
                      numArr[4]++
                  }
                  if(item.AN_Content=='6'){
                      numArr[5]++
                  }
                })                    
                var data = {
                    memberId :Cookies.get('qslmemberId'),
                    sort : 1,
                    coId : Cookies.get('qslCOID'),
                    type: numArr[0]+'|'+numArr[1] +'|'+numArr[2]+'|'+numArr[3]+'|'+numArr[4]+'|'+numArr[5]
                }
                console.log(data)
                fieldSave(data)
                .then(res => {           
                     console.log(res)
                      if(res.code=='200'){
                           that.dialogVisible = true
                           that.type1 = that.getMaxIndex(numArr)                                                            
                      }else{
                          that.$message('提交失败，请重试！')
                      }
                })
                .catch(err => {});
          }else{
               this.$confirm('当前题目没有完成，请选择！', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton:false,   
                                    
                  type: 'warning'
                })
          }
      },
      subForms(){
        var that = this
          var contentArr = []    
          this.questions.forEach(function(item) { 
                if(item.QT_Type =='2'){
                  var AN_Content = item.AN_Content_Arr.toString()
                }else{
                   var AN_Content = item.AN_Content.toString()
                }
                var tempData = 
                {
                  stid:item.QT_ID,
                  content:AN_Content
                }
                contentArr.push(tempData)
          })                
          var that = this
          var data = {
            memberId :Cookies.get('qslmemberId'),
            tiId : that.tiId ,
            content:JSON.stringify(contentArr),
            coId: Cookies.get('qslCOID') 
          } 
          saveAllAnswer(data)
          .then(res => {           
            that.LeaveIndex = false
            this.$router.go(-1);
          })
          .catch(err => {});
      } ,
      goAnchor(selector) {
          document.querySelector(selector).scrollIntoView({
              behavior: "smooth"
          });             
      },
      temp_arr(QT_Answer){
        var QT_Arr = QT_Answer.split('|') 
        var temp_arr = ''
        for(var i=0;i<QT_Arr.length;i++){
            var ii = QT_Arr[i]
            temp_arr+= Letter[ii]
        }
        return(temp_arr)        
      },
      getExamCardFun(){
            var that =this
             let listItems = this.questions
             listItems.forEach(function(item) { 
               var data =
                {
                  "re": 0,
                  "QT_Type": 1,
                  "answer": 0,
                  "AN_Content": 0,
                  "QT_Index": item.QT_Index
                }                                
                  that.list_dx.push(data)             
                
              })           

      },

    }
  };
</script>
<style scoped>
>>> .el-message-box__status.el-icon-warning{
  color:#F7413F
}

>>> .el-dialog{
  background:transparent;border:0;box-shadow:none
}
.subItems{
  font-size:14px;
  display:flex;
  padding:14px 24px 0 24px
}
.subItems .subl{
  width:670px;
  margin-right:60px
}
.subItems .items{
  color:#333333;
  line-height:22px;
}
.subItems .items div{
  margin:10px 0
}
.color_red{
  color:#F7413F
}
.color_blue{
  color:#4B9AFB
}

.subItems .res{
  width: 668px;
  height: 46px;
  line-height:46px;
  background: #f0f0f0;
  border-radius: 8px;
  margin-top:20px
}
.subItems .res2{
  padding:24px;
  background: #f0f0f0;
  line-height:22px;
  color:#ccc
}
.fbtn >>>.el-button{
  padding:0
}
>>>.el-textarea__inner
{
  width: 668px;
  height: 184px;
  background: #f0f0f0;
  border: 1px solid #dddddd;
  border-radius: 8px;
  padding:24px;
  font-size:14px;
}
.subItems .res span{
  padding:0 20px
}
 p{
  display:inline
}
.subItems .subr{
  flex:1;
  font-size:14px;
  color:#333;
  font-weight:bold
}
.subItems .title{
  margin-bottom:14px;
  line-height:24px
}
.subItems .d{
  font-size:14px;
  color:#333;
  font-weight:bold;
}
.subItems .s{
  color:#999;
  font-size:14px;
  margin-left:50px
}
.subItems .t{
  width: 44px;
  height: 19px;
  background: rgba(255,255,255,0.00);
  border: 1px solid #4b9afb;
  border-radius: 2px;
  font-size:12px;
  color:#4B9AFB;
  line-height:21px;
  padding:2px 3px
}
.cardItem{
padding:24px
}
.cardItem .t{
  margin:3px 0 15px 0;
}

.cardItem .item{
  width: 40px;
  height: 40px;
  background: #f0f0f0;
  border: 1px solid #dddddd;
  border-radius: 4px;
  margin-right: 15px;
  margin-bottom:15px;
  font-size:14px;
  color:#333;
  text-align: center;
  line-height: 40px;
   cursor: pointer;
}
.cardItem .select{
  color:#4B9AFB;
  border:1px solid #4B9AFB;
  background: #e4f0fe;
}
.cardItem .flex{ 
  flex-direction: row;
  flex-wrap: wrap;
 
}
.flexitem{
   overflow-y:scroll
}
.cardItem .st span{
  position: relative;
  flex:1;
  padding-left:20px;
  padding-bottom:15px
}
.cardItem .st span::before{
  content: '';
  position:absolute;
  left:0px;
  top:6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.cardItem .st .s1::before{ 
  background: #f0f0f0;
}
.cardItem .st .s2::before{ 
  background: #4B9AFB;
}
.cardFotter{
  height: 72px;
  background: #ffffff;
  width:100%;
  position: fixed;
  bottom:0;
  left:0;right: 0;
  z-index:3
}

.ksjg{
  background:#F0F0F0;
  margin:24px;
  padding:40px
}
.ksjg .flex{
  margin-bottom:40px ;  
}
.ksjg .flex div{
  flex:1
}
.ckjg{
  text-align:center;
  padding:16px 0 40px 0
}

.el-button{
  font-size:18px;
  padding:14px 20px
}
.etime{
  color:#F7413F;
  font-size:14px;
  margin-left:24px
}
.dep{
  background:url(../../assets/images/res1.png) no-repeat;
  background-size:cover;
  margin:35px auto;
  position:relative
}
.dep .in{  
  font-size: 18px;
  font-family: Source Han Sans CN, Source Han Sans CN-Normal;
  font-weight: Normal;
  text-align: left;
  color: #666666;
  line-height: 27px;
  margin:0  auto;
  padding-top:100px;
  text-align:center;
  margin:0 80px
}
.dep .in img{
  width:50%;margin:0 auto
}
.jiedu .l{
  font-size:20px;
  color:#333;
  border-top:1px dotted #ccc;
  padding:3% 0;
  margin-top:3%
}
.jiedu .d{
  text-align:left;
  line-height:150%;
  font-size:18px
}
>>> .el-radio__label{
  width: 700px;
  display: inline-block;
}

.fbtn{
  position:absolute;
  left:0px;
  width:100%;
  bottom:3%;
  right:0
}
.scrollCsss{
  position:fixed;width:285px;z-index:4;top:20px;bottom:90px
}
.fixdalert{
  position:fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  width:100%;
  height:100%; 
  z-index:5
}
.closex{
  position:absolute;
  right:-20px;
  top:0
}
</style>


// WEBPACK FOOTER //
// src/views/Test/employee.vue